import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login'
import Registry from "../components/Registry"
import Home from "../components/Home"
import Welcome from "../components/Welcome"
import Employee from "../components/Employee"
import Analyse from "../components/Analyse"
import Auths from "../components/Auths"
import Card from "../components/Card"
import Customer from "../components/Customer"
import FootServices from "../components/FootServices"
import InPurchaseApply from "../components/InPurchaseApply"
import InPurchaseApprove from "../components/InPurchaseApprove"
import InPurchasePrint from "../components/InPurchasePrint"
import Orgs from "../components/Orgs"
import OutPurchase from "../components/OutPurchase"
import OutStorage from "../components/OutStorage"
import Products from "../components/Products"
import Recharges from "../components/Recharges"
import Refund from "../components/Refund"
import ReturnPremium from "../components/ReturnPremium"
import Roles from "../components/Roles"
import Orders from "../components/Orders"
import Send from "../components/Send"
import Receive from "../components/Receive";
import Works from "../components/Works"
import Stock from "../components/Stock"
import Profit from "../components/Profit"
import Performance from "../components/Performance";
import Cash from "../components/Cash";
import PetCard from "../components/PetCard";
import Salary from "../components/Salary";
import Project from "../components/Project";
import Day from "../components/Day";
import OutOrg from "../components/OutOrg";
import CheckStock from "../components/CheckStock";
import ReportSet from "../components/ReportSet";
import PengPengMsg from "../components/message";
import PayType from "../components/PayType";
import Activity from "../components/Activity";
import Expend from "../components/Expend";
import ShopExpend from "../components/ShopExpend";
import EmployeeSubsidy from "../components/EmployeeSubsidy";
import EmployeeCost from "../components/EmployeeCost";
import ShopCost from "../components/ShopCost";
import EmployeeSubsidySet from "../components/EmployeeSubsidySet";
import EmployeeCostSet from "../components/EmployeeCostSet";
import ShopCostSet from "../components/ShopCostSet";
import SalaryCollect from "../components/SalaryCollect";
import WxBindPhone from "../components/WxBindPhone";
import SubmitOrder from "../components/SubmitOrder";
import OldOrderRefund from "../components/OldOrderRefund";
import OutStoragePrint from "../components/OutStoragePrint";
import OldOrders from "../components/OldOrders";
import ArrearageOrders from "../components/ArrearageOrders";
import CiCard from "../components/CiCard";
import versionTood from '@/libs/versionUpdate'
import DiscountTickets from "../components/DiscountTickets";
import AddDiscountTicket from "../components/AddDiscountTicket";
import Contents from "../components/Contents";
import Reserves from "../components/Reserves";
import AlertLine from "../components/AlertLine";
import ShopCb from "../components/ShopCb";
import MyYieldSet from "../components/MyYieldSet";
import MyYield from "../components/MyYield";
import UserCard from "../components/UserCard";
import PerfSet from "../components/PerfSet";
import UserPerfRule from "../components/UserPerfRule";
import UserPerfRuleList from "../components/UserPerfRuleList";
import ReportPerfRule from "../components/ReportPerfRule";
import WorkTask from "../components/WorkTask";
import bxSpSet from "../components/BxSpSet";
import newMember from "../components/NewMember";
import newMemberOrder from "../components/newMemberOrder";
import newSkOrder from "../components/NewSkOrder";
import EditOrder from "../components/EditOrder";
import NoOrderShop from "../components/NoOrderShop";
import MoreCustomer from "../components/MoreCustomer";
import OldCustomer from "../components/OldCustomer";
import NewEmployeeSubsidy from "../components/NewEmployeeSubsidy";
import CopyEmployeeSubsidy from "../components/CopyEmployeeSubsidy";
import NewEmployeeCost from "../components/NewEmployeeCost";
import CopyEmployeeCost from "../components/CopyEmployeeCost";
import NewShopCost from "../components/NewShopCost";
import CopyShopCost from "../components/CopyShopCost";
import SendReceive from "../components/SendReceive";
import NewSendPurchase from "../components/NewSendPurchase";
import EditEmployeeSubsidy from "../components/EditEmployeeSubsidy";
import EditEmployeeCost from "../components/EditEmployeeCost";
import EditShopCost from "../components/EditShopCost";
import UserCardList from "../components/UserCardList";
import EditUserCard from "../components/EditUserCard";
import MyYieList from "../components/MyYieList";
import StockPrint from "../components/StockPrint";
import ReportHyCz from "../components/ReportHyCz";
import BuyCkList from "../components/BuyCkList";
import ReportKdj from "../components/ReportKdj";
import ReportCk from "../components/ReportCk";
import NewAreaExpend from "../components/NewAreaExpend";
import AreaExpend from "../components/AreaExpend";
import ReportProductSale from "../components/ReportProductSale";
import ReportProductNum from "../components/ReportProductNum";
import NewMessage from "../components/NewMessage";
import OldRecharge from "../components/OldRecharge";
import UserInfo from "../components/UserInfo";


Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new Router({
  routes: [
    // {path: '/', redirect: '/home'},
    {path: '/login', component: Login},
    {path: '/registry', component: Registry},
    {path: '/wxBindPhone', component: WxBindPhone},
    {
      path: '/home', component: Home,
      redirect: '/welcome',
      children:[
        {path: '/welcome', component: Welcome},
        {path: '/employees', component: Employee},
        {path: '/works', component: Works},
        {path: '/customers', component: Customer},
        {path: '/card', component: Card},
        {path: '/recharges', component: Recharges},
        {path: '/returnPremium', component: ReturnPremium},
        {path: '/analyse', component: Analyse},
        {path: '/orders', component: Orders},
        {path: '/old/orders', component: OldOrders},
        {path: '/refund', component: Refund},
        {path: '/outPurchase', component: OutPurchase},
        {path: '/inPurchase/apply', component: InPurchaseApply},
        {path: '/inPurchase/approve', component: InPurchaseApprove},
        {path: '/inPurchase/print', component: InPurchasePrint},
        {path: '/outStorage/print', component: OutStoragePrint},
        {path: '/send', component: Send},
        // {path: '/receive', component: Receive},
        {path: '/receive', component: SendReceive},
        {path: '/outStorage', component: OutStorage},
        {path: '/products', component: Products},
        {path: '/footServices', component: FootServices},
        {path: '/orgs', component: Orgs},
        {path: '/roles', component: Roles},
        {path: '/auths', component: Auths},
        {path: '/stock', component: Stock},
        {path: '/profit', component: Profit},
        {path: '/performance', component: Performance},
        {path: '/cash', component: Cash},
        {path: '/petCard', component: PetCard},
        {path: '/salary', component: Salary},
        {path: '/project', component: Project},
        {path: '/day', component: Day},
        {path: '/outOrg', component: OutOrg},
        {path: '/checkStock', component: CheckStock},
        {path: '/reportSet', component: ReportSet},
        {path: '/pengpengMsg', component: PengPengMsg},
        {path: '/payType', component: PayType},
        {path: '/activity', component: Activity},
        {path: '/expendType', component: Expend},
        {path: '/shopExpend', component: ShopExpend},
        {path: '/employee/subsidy', component: EmployeeSubsidy},
        {path: '/employee/cost', component: EmployeeCost},
        {path: '/shop/cost', component: ShopCost},
        {path: '/employee/subsidy/set', component: EmployeeSubsidySet},
        {path: '/employee/cost/set', component: EmployeeCostSet},
        {path: '/shop/cost/set', component: ShopCostSet},
        {path: '/salary/collect', component: SalaryCollect},
        {path: '/submit/order', component: SubmitOrder},
        {path: '/oldOrderRefund', component: OldOrderRefund},
        {path: '/arrearageOrders', component: ArrearageOrders},
        {path: '/ciCard', component: CiCard},
        {path: '/discountTickets', component: DiscountTickets},
        {path: '/createDiscountTicket', component: AddDiscountTicket},
        {path: '/contents', component: Contents},
        {path: '/reserves', component: Reserves},
        {path: '/alert/line/set', component: AlertLine},
        {path: '/shop/cb', component: ShopCb},
        {path: '/my/yield/set', component: MyYieldSet},
        {path: '/my/yield', component: MyYield},
        {path: '/user/card', component: UserCard},
        {path: '/perf/set', component: PerfSet},
        {path: '/user/perf/rule', component: UserPerfRule},
        {path: '/user/perf/rule/list', component: UserPerfRuleList},
        {path: '/report/user/perf/rule', component: ReportPerfRule},
        {path: '/work/task', component: WorkTask},
        {path: '/system/bxSp/set', component: bxSpSet},
        {path: '/new/member', component: newMember},
        {path: '/new/member/order', component: newMemberOrder},
        {path: '/new/sk/order', component: newSkOrder},
        {path: '/edit/order', component: EditOrder},
        {path: '/no/order/shop', component: NoOrderShop},
        {path: '/more/customer', component: MoreCustomer},
        {path: '/hbq/customer', component: OldCustomer},
        {path: '/new/employee/subsidy', component: NewEmployeeSubsidy},
        {path: '/copy/employee/subsidy', component: CopyEmployeeSubsidy},
        {path: '/new/employee/cost', component: NewEmployeeCost},
        {path: '/copy/employee/cost', component: CopyEmployeeCost},
        {path: '/new/shop/cost', component: NewShopCost},
        {path: '/copy/shop/cost', component: CopyShopCost},
        {path: '/new/send/purchase', component: NewSendPurchase},
        {path: '/edit/employee/subsidy', component: EditEmployeeSubsidy},
        {path: '/edit/employee/cost', component: EditEmployeeCost},
        {path: '/edit/shop/cost', component: EditShopCost},
        {path: '/user/card/list', component: UserCardList},
        {path: '/edit/user/card', component: EditUserCard},
        {path: '/my/yie/list', component: MyYieList},
        {path: '/stock/print', component: StockPrint},
        {path: '/report/hy/cz', component: ReportHyCz},
        {path: '/buy/cika/list', component: BuyCkList},
        {path: '/report/kdj', component: ReportKdj},
        {path: '/report/ckjl', component: ReportCk},
        {path: '/new/area/expend', component: NewAreaExpend},
        {path: '/area/expend', component: AreaExpend},
        {path: '/report/product/sale/money', component: ReportProductSale},
        {path: '/report/product/sale/num', component: ReportProductNum},
        {path: '/new/message', component: NewMessage},
        {path: '/old/recharges', component: OldRecharge},
        {path: '/userinfo', component: UserInfo}
      ]
    }
  ]
})

//挂在路由导航守卫
router.beforeEach((to,from,next) => {

  versionTood.isNewVersion();

  if (to.path === '/login' || to.path === '/registry') return next();
  //获取token
  const token = window.sessionStorage.getItem("token");
  if (!token) return next('/login')
  next()
})

export default router







// WEBPACK FOOTER //
// ./src/router/router.js